import { useEffect, useState } from "react";

/**
 * Текущее время, обновляемое с заданным интервалом.
 *
 * Применять только в листьях дерева: тик часов перерисовывает компонент, и в
 * лесенке стакана это означало бы полную перерисовку раз в секунду без всякой
 * на то причины.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
